/**
 * ## Chart Controller
 *
 * @module src/controllers/chart
 */

"use strict";

const chart = require("../../components/chart");
const component = require("../../components/component");
const accordion = require("../../components/accordion");
const notification = require("../../components/notification");
const modal = require("../../components/modal");
const print = require("../../components/print");
const conf = require("../../config");
const loc = require("../location");
const tableslib = require("../../components/chart/tables");
const tabs = require("../../controllers/tabs");
const func = require("../../controllers/func");
const moment = require("moment-timezone");
const l = require("../../common").localization;

let location;
let dragIntervalID = null;
let templatedata = null;
const isDragging = false;

let mouseXPos = 0;
let mouseYPos = 0;

let lastTable = null;
let templateName;
let templateID;
let currentSectionID = 1;
let splitOverflow = {
  activity_id: null,
  count: 0,
  join: [],
};
let seatParty = {
  active: false,
  referrer: false,
  activity: {},
};

const preSelect = {
  active: false,
  tables: [],
};

/** Accordion
 */
const init = (kd) => {
  kd.localstore.data.op_state = "standard";

  kd.on("location.update", (data) => {
    kd.location = kd.doc("location")[0];
    loc.location = kd.location;
    templateReset(kd);
  });

  kd.on("location.initialize", (data) => {
    kd.location = kd.doc("location")[0];
    loc.location = kd.location;
    templateReset(kd);
  });

  kd.on("template.update", (data) => {
    kd.location = kd.doc("location")[0];
    loc.location = kd.location;
    templateReset(kd);
  });

  kd.on("splitOverflow", (data) => {
    if (data.hasOwnProperty("size")) {
      setSplitOverflow(data);
    } else {
      clearSplitOverflow();
    }
  });

  kd.location = kd.doc("location")[0];

  templatedata = Object.assign({}, kd.doc("template", kd.location.template)[0]);
  // templateID = kd.location.template;
  templateName = kd.doc("template", kd.location.template)[0].name;

  kd.chartdata = kd.doc("chart", kd.location.chart)[0];
  kd.templatedata = templatedata;

  chart.create(kd, (err, obj) => {
    // grab current state for editor

    switch (kd.localstore.data.op_state) {
      case "standard":
        standard(kd, obj);
        break;
      case "inline":
      case "chart":
        editor(kd, obj);
        break;
      case "section":
        section(kd, obj);
        break;
      default:
        break;
    }
  });

  $(document).on("mousemove", (e) => {
    mouseXPos = e.pageX;
    mouseYPos = e.pageY;
  });

  $(document).on("touchmove touchstart", (e) => {
    mouseXPos = parseInt(e.originalEvent.touches[0].pageX, 10);
    mouseYPos = parseInt(e.originalEvent.touches[0].pageY, 10);
  });

  $(document).mouseup((e) => {
    clearInterval(dragIntervalID);
  });

  $(document).on("touchend", (e) => {
    clearInterval(dragIntervalID);
  });

  $(document).bind("mousedown selectstart", (e) => {
    return $(e.target).is("input, textarea, select, option, html");
  });

  $("#layout_chart_header_4top_drop").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      type: "dropdown",
      position: "bottom",
      highlight: chart.getTurnTime(),
      adjust: {
        x: -40,
        y: -15,
      },
    };
    component.create(options, conf.vars.turnTimes, (err, value) => {
      const proposed = {
        domain: "location",
        _id: kd.location._id,
        baseTurn: value.value,
      };
      kd.update(proposed)
        .then((result) => {})
        .catch((err2) => {
          console.log("err2", err2);
        });
    });

    /*
        block.filter('layout_sidebar_content_standard', 'in');
        */
  });

  templateReset(kd);

  const options = {
    target_id: "layout_chart_section_basic",
    type: "accordion",
    mode: "section",
    sections: [
      {
        description: "Basic",
        data: conf.vars.sections,
      },
      {
        description: "Combinations",
        data: conf.vars.sections,
      },
    ],
  };
  const data = {
    kd,
  };
  accordion.create(options, data, (err, value) => {
    currentSectionID = value.value;
  });
};

const getSection = (kd, table) => {
  for (let i = 0; i < kd.templatedata.tables.length; ++i) {
    if (kd.templatedata.tables[i].table == table) {
      return kd.templatedata.tables[i].section;
    }
  }
  return 0;
};

const getServer = (kd, section) => {
  for (let i = 0; i < kd.location.assignments.length; ++i) {
    if (kd.location.assignments[i].section == section) {
      return kd.location.assignments[i].server;
    }
  }
  return section;
};

const isDisabled = (kd, table) => {
  if (kd.location.disabledTables.includes(table)) {
    return 1;
  }
  return 0;
};

const standard = (kd, obj) => {
  if (obj.action == "up" && obj.type !== "icon") {
    if (chart.getEmbedOverflow().active) {
      kd.emit("directseat", { preference: null });
      if (chart.getEmbedOverflow().count > obj.seat) {
        chart.addEmbedOverflow(obj.table);
        const opt = {
          position: "top",
          width: "90%",
          seconds: 0,
          block: "fullheader",
          h1: l.translate("Party size may be too large."),
          body: l.translate(
            "Please select additional table(s) to split this party or " +
              "press done if the party will fit as is."
          ),
          buttons: [
            {
              description: l.translate("Done"),
              value: "close",
            },
          ],
        };
        notification.create(opt, {}, (err, value) => {
          kd.send({
            type: "rpc",
            action: "select_table",
            payload: {
              tables: Object.assign([], chart.getEmbedOverflow().tables),
            },
          });
          chart.setEmbedOverflow(false);
          notification.destroy();
          kd.emit("chart.update", {});
        });
        kd.emit("chart.update", {});
      } else {
        notification.destroy();
        chart.setEmbedOverflow(false);
        kd.send({
          type: "rpc",
          action: "select_table",
          payload: {
            tables: [obj.table],
          },
        });
        kd.emit("chart.update", {});
      }
    } else if (modal.getPreSelect().active) {
      // preSelect.tables.push(obj.table);
      if (modal.addPreSelect(obj.table)) {
        notification.appendBody(`${obj.table}, `);
      }
    } else if (seatParty.active) {
      if (!kd.location.disabledTables.includes(obj.table)) {
        if (obj.activity_id === undefined) {
          kd.emit("directseat", { preference: null });
          notification.destroy();
          const proposedX = Object.assign({}, seatParty.activity);
          seatParty.active = false;
          if (
            seatParty.hasOwnProperty("referrer") &&
            seatParty.referrer.length > 0
          ) {
            tabs.tab(kd, seatParty.referrer);
          }
          proposedX.transferredFromTable = seatParty.activity.table;
          proposedX.table = obj.table;
          proposedX.join = [];
          proposedX.domain = "activity";
          proposedX.status = 3;
          proposedX.tableStatus = 2;
          proposedX.trigger = [""];
          proposedX.table = obj.table;
          proposedX.section = getSection(kd, obj.table);
          proposedX.server = getServer(kd, proposedX.section);
          proposedX.statusTimes.seated = parseInt(moment().format("X"), 10);
          if (!proposedX.hasOwnProperty("alerts")) {
            proposedX.alerts = 0;
          }
          if (seatParty.activity.hasOwnProperty("_id")) {
            proposedX._id = seatParty.activity._id;
          }
          // delete proposedX.waited;
          chart.clearHighlight();
          kd.update(proposedX)
            .then((result) => {
              if (obj.seat < result.size) {
                splitOverflow = {
                  count: result.size - obj.seat,
                  activity: Object.assign({}, result),
                  join: [],
                };
                const opt = {
                  position: "top",
                  width: "90%",
                  seconds: 0,
                  block: "fullheader",
                  h1: l.translate(
                    "Party size may be too large to move to that table."
                  ),
                  body: l.translate(
                    "Please optionally select additional table(s) to " +
                      "split this party and press done when complete."
                  ),
                  buttons: [
                    {
                      description: l.translate("Done"),
                      value: "close",
                    },
                  ],
                };
                notification.create(opt, {}, (err, value) => {
                  splitOverflow.count = 0;
                  splitOverflow.join = [];
                  notification.destroy();
                  if (
                    kd.location.hasOwnProperty("chitAutomatic") &&
                    kd.location.chitAutomatic &&
                    kd.location.hasOwnProperty("chitSeat") &&
                    kd.location.chitSeat
                  ) {
                    const opt2 = {
                      type: "seated",
                      location: kd.location,
                    };
                    print.create(opt2, proposedX);
                  }
                });
              } else {
                if (
                  kd.location.hasOwnProperty("chitAutomatic") &&
                  kd.location.chitAutomatic &&
                  kd.location.hasOwnProperty("chitSeat") &&
                  kd.location.chitSeat
                ) {
                  const opt = {
                    type: "seated",
                    location: kd.location,
                  };
                  print.create(opt, proposedX);
                }
              }
              if (
                proposedX.hasOwnProperty("res_id") &&
                proposedX.res_id !== 0
              ) {
                const proposedR = {
                  domain: "reservation",
                  _id: proposedX.res_id,
                  status: 4,
                };
                return kd
                  .update(proposedR)
                  .then((result2) => {
                    kd.emit("chart.update", {});
                  })
                  .catch((err) => {
                    console.log("err", err);
                  });
              }
            })
            .catch((err) => {
              console.log("err", err);
            });
        }
      }
    } else if (splitOverflow.count > 0) {
      if (obj.activity_id === undefined && obj.disabled !== 1) {
        kd.emit("directseat", { preference: null });
        if (splitOverflow.join.length) {
          // add to current join
          splitOverflow.join.push({
            id: splitOverflow.join.length + 1,
            table: obj.table,
          });
        } else {
          // create join
          splitOverflow.join = [
            {
              id: 1,
              table: obj.table,
            },
          ];
        }
        const proposed = {
          _id: splitOverflow.activity._id,
          domain: "activity",
          join: splitOverflow.join,
        };
        kd.update(proposed)
          .then((result) => {})
          .catch((err) => {
            console.log("err", err);
          });
      }
    } else if (kd.usage == "embed") {
      // let orders = kd.find('activity', { table: obj.table });
      const orders = kd.whereSort(
        "activity",
        (act) => {
          if (act.status === 3) {
            if (act.table === obj.table) {
              return true;
            }
            if (act.hasOwnProperty("join") && act.join.length > 0) {
              for (let i = 0; i < act.join.length; ++i) {
                if (act.join[i].table === obj.table) {
                  return true;
                }
              }
            }
          }
        },
        (obj1, obj2) => {
          if (obj1.statusTimes.added == obj2.statusTimes.added) {
            return 0;
          }
          if (obj1.statusTimes.added > obj2.statusTimes.added) {
            return 1;
          }
          if (obj1.statusTimes.added < obj2.statusTimes.added) {
            return -1;
          }
        }
      );
      if (orders.length === 0) {
        displayEmbedOrderContext(kd, obj);
      } else if (orders.length === 1) {
        displayEmbedOrderContext(kd, obj);
      } else {
        const optionsm = {
          target_id: obj.target_id,
          type: "accordion",
          mode: "embed_context_table_multiple",
          position: "right",
          adjust: {
            x: (chart.iconSize / 2 + 8) * chart.getScale(),
            y: (chart.iconSize / 2) * chart.getScale(),
          },
        };
        const datam = {
          location: kd.location,
          table: $(`#${obj.target_id}`).data("table"),
          disabled: isDisabled(kd, $(`#${obj.target_id}`).data("table")),
          seats: $(`#${obj.target_id}`).data("seat"),
          orders,
          kd,
        };
        if (obj.activity_id) {
          datam.activity = kd.doc("activity", obj.activity_id)[0];
        }
        component.create(optionsm, datam, (err, compData) => {
          obj.activity_id = compData.order._id;
          displayEmbedOrderContext(kd, obj);
        });
      }
    } else {
      const options = {
        target_id: obj.target_id,
        type: "accordion",
        mode: "context_table",
        position: "right",
        adjust: {
          x: (chart.iconSize / 2 + 8) * chart.getScale(),
          y: (chart.iconSize / 2) * chart.getScale(),
        },
      };
      const data = {
        location: kd.location,
        table: $(`#${obj.target_id}`).data("table"),
        disabled: isDisabled(kd, $(`#${obj.target_id}`).data("table")),
        seats: $(`#${obj.target_id}`).data("seat"),
        kd,
      };
      if (obj.activity_id) {
        data.activity = kd.doc("activity", obj.activity_id)[0];
      }

      component.create(options, data, (err, compData) => {
        const rightNow = parseInt(moment().format("X"), 10);
        if (!data.hasOwnProperty("section")) {
          data.section = getSection(kd, data.table);
        }
        const notes = [];
        kd.location.notes.forEach((note) => {
          notes.push({
            id: note.id,
            value: note.description,
            active: 0,
          });
        });

        switch (compData.type) {
          case "party_size": {
            const proposed = {
              domain: "activity",
              status: 3,
              type: 5,
              statusTimes: {
                added: rightNow,
                seated: rightNow,
              },
              size: parseInt(compData.value, 10),
              tableStatus: 2,
              notes,
              alerts: 0,
              waited: 0,
              quoted: 0,
              table: data.table,
              section: data.section,
              server: getServer(kd, data.section),
              disabled: data.disabled,
              name: l.translate("Direct Seating"),
            };
            kd.update(proposed)
              .then((result) => {
                if (compData.seats < compData.value) {
                  splitOverflow = {
                    count: compData.value - compData.seats,
                    activity: Object.assign({}, result),
                    join: [],
                  };
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 0,
                    block: "fullheader",
                    h1: l.translate(
                      "Party size may be too large for " + "selected table."
                    ),
                    body: l.translate(
                      "Please optionally select additional " +
                        "table(s) to split this party and press done when " +
                        "complete."
                    ),
                    buttons: [
                      {
                        description: l.translate("Done"),
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err2, value) => {
                    splitOverflow.count = 0;
                    splitOverflow.join = [];
                    notification.destroy();
                    if (
                      kd.location.hasOwnProperty("chitAutomatic") &&
                      kd.location.chitAutomatic &&
                      kd.location.hasOwnProperty("chitSeat") &&
                      kd.location.chitSeat
                    ) {
                      const opt2 = {
                        type: "seated",
                        location: kd.location,
                      };
                      print.create(opt2, proposed);
                    }
                  });
                } else {
                  if (
                    kd.location.hasOwnProperty("chitAutomatic") &&
                    kd.location.chitAutomatic &&
                    kd.location.hasOwnProperty("chitSeat") &&
                    kd.location.chitSeat
                  ) {
                    const opt3 = {
                      type: "seated",
                      location: kd.location,
                    };
                    print.create(opt3, proposed);
                  }
                }
              })
              .catch((err3) => {
                console.log("err3", err3);
              });
            break;
          }
          case "table_status": {
            if (data.activity !== undefined) {
              let status = 3;
              if (compData.value == "1") {
                status = 5;
              }
              const statusTimes = Object.assign({}, data.activity.statusTimes);
              statusTimes.closed = parseInt(moment().format("X"), 10);
              const proposed = {
                _id: data.activity._id,
                domain: "activity",
                statusTimes,
                status,
                tableStatus: compData.value,
              };
              kd.update(proposed)
                .then((result) => {})
                .catch((err4) => {
                  console.log("err4", err4);
                });
            } else {
              // disabled or enabled table
              if (compData.value == "0") {
                for (let i = 0; i < kd.location.disabledTables.length; ++i) {
                  if (kd.location.disabledTables[i] == data.table) {
                    kd.location.disabledTables.splice(i, 1);
                    break;
                  }
                }
              } else {
                kd.location.disabledTables.push(data.table);
              }

              const proposed = {
                domain: "location",
                _id: kd.location._id,
                _kd: {
                  mergerule: "REPLACE",
                },
                disabledTables: kd.location.disabledTables,
              };
              kd.update(proposed)
                .then((result) => {})
                .catch((err5) => {
                  console.log("err5", err5);
                });
            }
            break;
          }
          case "table_section": {
            if (data.activity !== undefined) {
              const proposed = {
                _id: data.activity._id,
                domain: "activity",
                section: compData.value,
                server: getServer(kd, compData.value),
              };
              kd.update(proposed)
                .then((result) => {})
                .catch((err6) => {
                  console.log("err6", err6);
                });
            }
            break;
          }
          case "waitlist_moveparty": {
            const opt = {
              position: "top",
              width: "90%",
              seconds: 0,
              block: "full",
              color: "#09e202",
              h1: l.translate("Choose a new table"),
              body: "",
              buttons: [
                {
                  description: l.translate("ok"),
                  value: "close",
                },
              ],
            };
            notification.create(opt, {}, (err7, value) => {
              // notification.destroy();
            });

            data.activity.join = [];

            seatParty = {
              active: true,
              activity: Object.assign({}, data.activity),
            };

            break;
          }
          case "waitlist_details": {
            const modalData = {
              opt: {
                width: "90%",
                type: "addparty",
                subtype: "waitlist",
                mode: "waitlist",
                h1: "Dialog Header",
                body: "This is the body text inside the dialog box",
                buttons: [
                  {
                    description: l.translate("cancel"),
                    value: "cancel...",
                  },
                  {
                    description: l.translate("close"),
                    value: "close",
                  },
                  {
                    description: l.translate("third"),
                    value: "close",
                  },
                ],
              },
              data: {
                kd,
                location: kd.location,
                activity: data.activity,
              },
            };
            kd.emit("modal", modalData);
            break;
          }
          case "waitlist_backtoqueue": {
            if (data.activity !== undefined) {
              const proposed = {
                _id: data.activity._id,
                domain: "activity",
                status: 1,
              };
              kd.update(proposed)
                .then((result) => {})
                .catch((err8) => {
                  console.log("err8", err8);
                });
            }
            break;
          }
          case "waitlist_printchit": {
            if (data.activity !== undefined) {
              modal.destroy();
              setTimeout(() => {
                const opt = {
                  type: "seated",
                  location: kd.location,
                };
                print.create(opt, data.activity);
              }, 10);
              break;
            }
            break;
          }
          default:
            break;
        }
      });
    }
  }
};

const displayEmbedOrderContext = (kd, obj) => {
  const options = {
    target_id: obj.target_id,
    type: "accordion",
    mode: "embed_context_table",
    position: "right",
    adjust: {
      x: (chart.iconSize / 2 + 8) * chart.getScale(),
      y: (chart.iconSize / 2) * chart.getScale(),
    },
  };

  const data = {
    location: Object.assign({}, kd.location),
    table: $(`#${obj.target_id}`).data("table"),
    disabled: isDisabled(kd, $(`#${obj.target_id}`).data("table")),
    seats: $(`#${obj.target_id}`).data("seat"),
    kd,
  };

  if (obj.activity_id) {
    data.activity = kd.doc("activity", obj.activity_id)[0];
  }
  setTimeout(() => {
    component.create(options, data, (err, compData) => {
      if (!data.hasOwnProperty("section")) {
        data.section = 0;
        data.server = "";
      }
      switch (compData.value) {
        case "new_order":
          kd.send({
            type: "rpc",
            action: "new_order",
            payload: {
              _id: obj.activity_id,
              tables: [obj.table],
            },
          });
          break;
        case "open_order": {
          kd.send({
            type: "rpc",
            action: "open_order",
            payload: {
              _id: obj.activity_id,
              tables: [obj.table],
            },
          });

          break;
        }
        case "new_segment":
          kd.send({
            type: "rpc",
            action: "new_segment",
            payload: {
              _id: obj.activity_id,
              tables: [obj.table],
            },
          });
          break;
        case "pay_now":
          kd.send({
            type: "rpc",
            action: "pay_now",
            payload: {
              _id: obj.activity_id,
              tables: [obj.table],
            },
          });
          break;
        default:
          break;
      }
    });
  }, 0);
};

const editor = (kd, obj) => {
  if (func.isMobile()) {
    mouseXPos = obj.mouseXPos;
    mouseYPos = obj.mouseYPos;
  }
  clearInterval(dragIntervalID);
  switch (obj.source) {
    case "standard":
      switch (obj.action) {
        case "down": {
          // touch requires some delay to actually receive the update of the finger position
          // on screen
          let timing = 0;
          if (func.isMobile()) {
            timing = 1;
          }
          setTimeout(() => {
            if (!chart.getActive()) {
              const x_offset =
                mouseXPos -
                $(`#${obj.target_id}`).offset().left +
                $("#layout_chart_main").offset().left;
              const y_offset =
                mouseYPos -
                $(`#${obj.target_id}`).offset().top +
                $("#layout_chart_main").offset().top;

              // start drag if mode is not move screen
              TweenMax.to(`#${obj.target_id}`, 0, {
                x: (mouseXPos - x_offset) / chart.getScale(),
                y: (mouseYPos - y_offset) / chart.getScale(),
                ease: Power2.easeOut,
              });
              dragIntervalID = setInterval(() => {
                if (obj.multiSelect.active) {
                  for (let i = 0; i < obj.multiSelect.tables.length; ++i) {
                    TweenMax.to(`#table_${obj.multiSelect.tables[i].id}`, 0, {
                      x:
                        (mouseXPos -
                          x_offset -
                          ($(`#${obj.target_id}`).data("x") -
                            obj.multiSelect.tables[i].x)) /
                        chart.getScale(),
                      y:
                        (mouseYPos -
                          y_offset -
                          ($(`#${obj.target_id}`).data("y") -
                            obj.multiSelect.tables[i].y)) /
                        chart.getScale(),
                      ease: Power2.easeOut,
                    });
                  }
                } else {
                  TweenMax.to(`#${obj.target_id}`, 0, {
                    x: (mouseXPos - x_offset) / chart.getScale(),
                    y: (mouseYPos - y_offset) / chart.getScale(),
                    ease: Power2.easeOut,
                  });
                }
              }, 16);
            }
          }, timing);
          break;
        }
        case "drag": {
          if (!chart.getActive()) {
            if (obj.multiSelect.active) {
              for (let a = 0; a < obj.multiSelect.tables.length; ++a) {
                $(`#table_${obj.multiSelect.tables[a].id}`).data(
                  "x",
                  $(`#table_${obj.multiSelect.tables[a].id}`).position().left /
                    chart.getScale()
                );
                $(`#table_${obj.multiSelect.tables[a].id}`).data(
                  "y",
                  $(`#table_${obj.multiSelect.tables[a].id}`).position().top /
                    chart.getScale()
                );
                for (let i = 0; i < kd.chartdata.tables.length; ++i) {
                  if (
                    kd.chartdata.tables[i].id == obj.multiSelect.tables[a].id
                  ) {
                    kd.chartdata.tables[i].x =
                      $(`#table_${obj.multiSelect.tables[a].id}`).position()
                        .left / chart.getScale();
                    kd.chartdata.tables[i].y =
                      $(`#table_${obj.multiSelect.tables[a].id}`).position()
                        .top / chart.getScale();
                    break;
                  }
                }
              }
            } else {
              $(`#${obj.target_id}`).data(
                "x",
                $(`#${obj.target_id}`).position().left / chart.getScale()
              );
              $(`#${obj.target_id}`).data(
                "y",
                $(`#${obj.target_id}`).position().top / chart.getScale()
              );
              for (let i = 0; i < kd.chartdata.tables.length; ++i) {
                if (kd.chartdata.tables[i].id == obj.id) {
                  if (kd.localstore.data.op_state === "inline") {
                    kd.chartdata.tables[i].altx =
                      $(`#${obj.target_id}`).position().left / chart.getScale();
                    kd.chartdata.tables[i].alty =
                      $(`#${obj.target_id}`).position().top / chart.getScale();
                  } else {
                    kd.chartdata.tables[i].x =
                      $(`#${obj.target_id}`).position().left / chart.getScale();
                    kd.chartdata.tables[i].y =
                      $(`#${obj.target_id}`).position().top / chart.getScale();
                  }
                  break;
                }
              }
            }
          }
          // kd.emit('chart.update', {});
          break;
        }
        case "pixelUp":
        case "pixelLeft":
        case "pixelRight":
        case "pixelDown": {
          if (!chart.getActive()) {
            if (obj.multiSelect.active) {
              for (let a = 0; a < obj.multiSelect.tables.length; ++a) {
                for (let i = 0; i < kd.chartdata.tables.length; ++i) {
                  if (
                    kd.chartdata.tables[i].id == obj.multiSelect.tables[a].id
                  ) {
                    if (obj.action === "pixelUp") {
                      --kd.chartdata.tables[i].y;
                    } else if (obj.action === "pixelDown") {
                      ++kd.chartdata.tables[i].y;
                    } else if (obj.action === "pixelLeft") {
                      --kd.chartdata.tables[i].x;
                    } else if (obj.action === "pixelRight") {
                      ++kd.chartdata.tables[i].x;
                    }
                    TweenMax.to(`#table_${kd.chartdata.tables[i].id}`, 0, {
                      x: kd.chartdata.tables[i].x,
                      y: kd.chartdata.tables[i].y,
                    });
                    break;
                  }
                }
              }
            } else {
              for (let i = 0; i < kd.chartdata.tables.length; ++i) {
                if (kd.chartdata.tables[i].id == obj.id) {
                  if (obj.action === "pixelUp") {
                    --kd.chartdata.tables[i].y;
                  } else if (obj.action === "pixelDown") {
                    ++kd.chartdata.tables[i].y;
                  } else if (obj.action === "pixelLeft") {
                    --kd.chartdata.tables[i].x;
                  } else if (obj.action === "pixelRight") {
                    ++kd.chartdata.tables[i].x;
                  }
                  TweenMax.to(`#${obj.target_id}`, 0, {
                    x: kd.chartdata.tables[i].x,
                    y: kd.chartdata.tables[i].y,
                  });
                  break;
                }
              }
            }
          }
          break;
        }
        case "up": {
          // release
          let tabledata;
          for (let i = 0; i < kd.chartdata.tables.length; ++i) {
            if (obj.id == kd.chartdata.tables[i].id) {
              tabledata = kd.chartdata.tables[i];
            }
          }
          const options = {
            target_id: obj.target_id,
            type: "tableedit",
            tabletype: obj.type,
            position: "right",
            adjust: {
              x: (chart.iconSize / 2 + 8) * chart.getScale(),
              y: (chart.iconSize / 2) * chart.getScale(),
            },
          };
          const data = {
            location: kd.location,
            tabledata,
            chartdata: kd.chartdata,
            table: $(`#${obj.target_id}`).data("table"),
            id: obj.id,
          };
          if (kd.localstore.data.op_state !== "inline") {
            component.create(options, data, (err, compData) => {
              lastTable = compData.table;
              for (let i = 0; i < kd.chartdata.tables.length; ++i) {
                if (data.id == kd.chartdata.tables[i].id) {
                  switch (compData.type) {
                    case "numchange":
                      kd.chartdata.tables[i].table = compData.table;
                      break;
                    case "rotate":
                      kd.chartdata.tables[i].rotation =
                        kd.chartdata.tables[i].rotation + 22.5;
                      break;
                    case "delete":
                      kd.chartdata.tables.splice(i, 1);
                      break;
                    case "preference1":
                      kd.chartdata.tables[i].preference1 = compData.preference;
                      break;
                    case "preference2":
                      kd.chartdata.tables[i].preference2 = compData.preference;
                      break;
                    case "scaleUp":
                      if (
                        kd.chartdata.tables[i].hasOwnProperty("scale") &&
                        kd.chartdata.tables[i].scale
                      ) {
                        kd.chartdata.tables[i].scale =
                          kd.chartdata.tables[i].scale + 0.4;
                      } else {
                        kd.chartdata.tables[i].scale = 1.4;
                      }
                      break;
                    case "scaleDown":
                      if (
                        kd.chartdata.tables[i].hasOwnProperty("scale") &&
                        kd.chartdata.tables[i].scale
                      ) {
                        kd.chartdata.tables[i].scale =
                          kd.chartdata.tables[i].scale - 0.4;
                      } else {
                        kd.chartdata.tables[i].scale = 0.6;
                      }
                      if (kd.chartdata.tables[i].scale < 0.6) {
                        kd.chartdata.tables[i].scale = 0.6;
                      }
                      break;
                    case "widthUp":
                      if (
                        kd.chartdata.tables[i].hasOwnProperty("scaleX") &&
                        kd.chartdata.tables[i].scaleX
                      ) {
                        kd.chartdata.tables[i].scaleX =
                          kd.chartdata.tables[i].scaleX + 0.4;
                      } else {
                        kd.chartdata.tables[i].scaleX = 1.4;
                      }
                      break;
                    case "widthDown":
                      if (
                        kd.chartdata.tables[i].hasOwnProperty("scaleX") &&
                        kd.chartdata.tables[i].scaleX
                      ) {
                        kd.chartdata.tables[i].scaleX =
                          kd.chartdata.tables[i].scaleX - 0.4;
                      } else {
                        kd.chartdata.tables[i].scaleX = 0.6;
                      }
                      if (kd.chartdata.tables[i].scaleX < 0.6) {
                        kd.chartdata.tables[i].scaleX = 0.6;
                      }
                      break;
                    case "heightUp":
                      if (
                        kd.chartdata.tables[i].hasOwnProperty("scaleY") &&
                        kd.chartdata.tables[i].scaleY
                      ) {
                        kd.chartdata.tables[i].scaleY =
                          kd.chartdata.tables[i].scaleY + 0.4;
                      } else {
                        kd.chartdata.tables[i].scaleY = 1.4;
                      }
                      break;
                    case "heightDown":
                      if (
                        kd.chartdata.tables[i].hasOwnProperty("scaleY") &&
                        kd.chartdata.tables[i].scaleY
                      ) {
                        kd.chartdata.tables[i].scaleY =
                          kd.chartdata.tables[i].scaleY - 0.4;
                      } else {
                        kd.chartdata.tables[i].scaleY = 0.6;
                      }
                      if (kd.chartdata.tables[i].scaleY < 0.6) {
                        kd.chartdata.tables[i].scaleY = 0.6;
                      }
                      break;
                    case "label":
                      kd.chartdata.tables[i].label = compData.label;
                      break;
                    default:
                      break;
                  }
                  break;
                }
              }
              kd.emit("chart.update", {});
            });
          }
          break;
        }
        default:
          break;
      }
      break;
    case "editor":
      switch (obj.action) {
        case "down": {
          // start drag
          $("#editor_drag").data("seat", obj.seat);
          $("#editor_drag").data("source", obj.source);
          $("#editor_drag").data("type", obj.type);
          $("#editor_drag").css("display", "block");
          $("#editor_drag").html(tableslib.lib[`${obj.type}_${obj.seat}`]);
          TweenMax.to("#editor_drag", 0, {
            x: mouseXPos - 64,
            y: mouseYPos - 64,
            ease: Power2.easeOut,
          });
          dragIntervalID = setInterval(() => {
            TweenMax.to("#editor_drag", 0, {
              x: mouseXPos - 64,
              y: mouseYPos - 64,
              ease: Power2.easeOut,
            });
          }, 16);
          break;
        }
        case "drag": {
          // check bounds, and add to kd.chartdata (?)
          let new_id = 0;
          let new_table = 0;
          if (
            $(window).width() - $("#editor_drag").offset().left > 284 &&
            $("#editor_drag").offset().top > 36
          ) {
            kd.chartdata.tables.forEach((table) => {
              if (new_id < table.id) {
                new_id = table.id;
              }
            });
            if (obj.type != "icon") {
              kd.chartdata.tables.forEach((table) => {
                if (
                  !isNaN(table.table) &&
                  parseInt(new_table, 10) <= parseInt(table.table, 10)
                ) {
                  new_table = parseInt(table.table, 10) + 1;
                }
              });
              if (lastTable) {
                ++lastTable;
                new_table = lastTable;
              }
            }
            if (!isNaN(new_table)) {
              new_table = Number(new_table);
            }
            kd.chartdata.tables.push({
              id: new_id + 1,
              table: new_table,
              x:
                ($("#editor_drag").offset().left -
                  $("#layout_chart_main").offset().left) /
                chart.getScale(),
              y:
                ($("#editor_drag").offset().top -
                  $("#layout_chart_main").offset().top) /
                chart.getScale(),
              type: $("#editor_drag").data("type"),
              seats: $("#editor_drag").data("seat"),
              rotation: 0,
              room: kd.localstore.data.room,
            });
            kd.emit("chart.update", {});
          }
          $("#editor_drag").css("display", "none");
          break;
        }
        case "up": {
          // nothing here
          break;
        }
        default:
          break;
      }
      break;
    default:
      break;
  }
};

const section = (kd, obj) => {
  if (obj.action == "up" && obj.type !== "icon") {
    let match = false;
    for (let i = 0; i < templatedata.tables.length; ++i) {
      if (obj.table == templatedata.tables[i].table) {
        // match
        match = true;
        if (currentSectionID == 0) {
          templatedata.tables.splice(i, 1);
        } else {
          templatedata.tables[i].section = currentSectionID;
        }
        break;
      }
    }
    if (!match) {
      let new_id = 0;
      templatedata.tables.forEach((table) => {
        if (new_id < table.id) {
          new_id = table.id;
        }
      });
      templatedata.tables.push({
        id: new_id + 1,
        table: obj.table,
        section: currentSectionID,
      });
    }

    kd.templatedata = templatedata;
    kd.emit("template.update", {});
  }
};

const templateReset = (kd) => {
  setTimeout(() => {
    $("#layout_chart_template_select")
      .html(`${kd.templatedata.name}&nbsp;&nbsp;\
            <i class="fa fa-angle-down fa-lg"></i>`);

    const templateArray = [];

    const templates = Object.assign(
      [],
      kd.find(
        "template",
        {
          $and: [{ active: 1 }, { chart: kd.location.chart }],
        },
        "order"
      )
    );
    templates.forEach((template) => {
      templateArray.push({
        description: template.name,
        value: template._id,
      });
    });
    $("#layout_chart_template_select").fastClick((e) => {
      switch (kd.localstore.data.op_state) {
        case "standard": {
          const options = {
            target_id: e.target.id,
            type: "dropdown",
            position: "bottom",
            highlight: kd.templatedata.name,
            adjust: {
              x: -20,
              y: -15,
            },
          };
          component.create(options, templateArray, (err, value) => {
            const proposed = {
              domain: "location",
              _id: kd.location._id,
              template: value.value,
            };
            kd.update(proposed)
              .then((result) => {
                templatedata = Object.assign(
                  {},
                  kd.doc("template", value.value)[0]
                );
                kd.templatedata = templatedata;
                // if (kd.usage === 'embed') {
                kd.emit("chart.update", {});
                // }
              })
              .catch((err2) => {
                console.log("err2", err2);
              });
          });
          break;
        }
        case "inline":
        case "chart": {
          break;
        }
        case "section": {
          const options = {
            target_id: e.target.id,
            type: "dropdown",
            position: "left",
            highlight: kd.templatedata.name,
            adjust: {
              x: 5,
              y: 25,
            },
          };
          component.create(options, templateArray, (err, value) => {
            $("#layout_chart_template_select")
              .html(`${value.description}&nbsp;&nbsp;\
                    <i class="fa fa-angle-down fa-lg"></i>`);
            kd.location.template = value.value;
            templatedata = Object.assign(
              {},
              kd.doc("template", value.value)[0]
            );
            kd.templatedata = templatedata;
            kd.emit("chart.update", {});
          });
          break;
        }
        default:
          break;
      }
    });
  }, 50);
};

const resetZoom = () => {
  chart.resetZoom();
};

const enable = () => {
  chart.enable();
};

const disable = () => {
  chart.disable();
};

const setSeatParty = (activity, referrer) => {
  seatParty = {
    active: true,
    referrer,
    activity,
  };
};

const clearSeatParty = () => {
  seatParty = {
    active: false,
    referrer: false,
    activity: {},
  };
};

const setSplitOverflow = (activity) => {
  splitOverflow = {
    count: activity.size,
    activity: Object.assign({}, activity),
    join: Object.assign([], activity.join),
  };
};

const clearSplitOverflow = () => {
  splitOverflow.count = 0;
  splitOverflow.join = [];
};

module.exports = {
  enable,
  disable,
  resetZoom,
  chart,
  init,
  setSeatParty,
  clearSeatParty,
  setSplitOverflow,
  clearSplitOverflow,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/chart/index.js
 **/